// @ts-nocheck
export default function (store, { host }) {
  const CareTeam = store.defineModel('careTeam', {
    parseAttrs(attrs) {
      return attrs;
    },

    relations: {
      belongsTo: {
        organization: { type: 'organization', foreignKey: 'organizationId' },
      },
    },
  });

  return CareTeam;
}
